import axios from 'axios';
import { updateCartUI } from './ui.js';
import { mensajeDeError } from './operations.js';

/**
 * Combo por pasos en el menú (client.partials.combo-dia).
 *
 * Cada acción pasa por los endpoints del carrito de siempre (mismos controles de
 * tope y adicionales) y después se vuelve a pedir el panel del día a combo.dia:
 * el paso en el que está el día se deduce del carrito en el servidor.
 *
 * Cada plato elegido va con el combo que se está armando (data-combo) y el UUID
 * del combo en curso (data-grupo, vacío si se arranca uno): el servidor lo pone
 * en ese combo o le da uno nuevo.
 */

function ocupado(panel, estado) {
    panel.find('button').prop('disabled', estado);
}

function error(e, porDefecto) {
    console.error(porDefecto, e);
    updateCartUI.showToast(mensajeDeError(e, porDefecto), '#dc3545');
}

/**
 * Reemplaza el panel por el que devuelve el servidor. Sin `combo`, se mantiene
 * el combo en curso del panel; con `soltar`, no se manda ninguno (el servidor
 * vuelve a deducirlo del carrito).
 */
function refrescar(panel, { combo = null, nuevo = false, soltar = false } = {}) {
    ocupado(panel, true);

    return axios.get(panel.data('url'), {
        params: {
            on: panel.data('on'),
            combo: soltar ? undefined : (combo || panel.attr('data-combo') || undefined),
            nuevo: nuevo ? 1 : undefined,
        },
    })
    .then(response => {
        const nuevoPanel = $(response.data);
        panel.replaceWith(nuevoPanel);
        // El ✓ de la solapa del día sigue al estado nuevo.
        $('#' + nuevoPanel.data('tab')).find('.combo-dia-completo')
            .toggleClass('d-none', parseInt(nuevoPanel.attr('data-completo')) !== 1);
        alPanel(nuevoPanel);
    })
    .catch(e => {
        error(e, 'No se pudo actualizar el combo');
        ocupado(panel, false);
    });
}

/**
 * Si el panel nuevo quedó por encima de la pantalla (una lista larga en el
 * celular), se sube hasta su principio. El header es fixed-top.
 */
function alPanel(panel) {
    const header = document.querySelector('.site-header');
    const offset = (header ? header.offsetHeight : 0) + 16;
    const top = panel[0].getBoundingClientRect().top;

    if (top < offset) {
        window.scrollTo({ top: window.scrollY + top - offset, behavior: 'smooth' });
    }
}

function elegir(btn) {
    const panel = btn.closest('.combo-dia');
    const plato = btn.closest('.plato');

    // Igual que "Añadir al carrito": si la vianda ofrece adicionales, elegir uno es obligatorio.
    const bloque = plato.find('.adicionales');
    const adicionales = bloque.find('input[type="radio"]:checked').map(function () {
        return parseInt($(this).val());
    }).get();
    const aviso = bloque.find('.adicional-requerido');

    if (bloque.length && adicionales.length === 0) {
        aviso.removeClass('d-none');
        return;
    }
    aviso.addClass('d-none');

    ocupado(panel, true);
    btn.find('.spinner').removeClass('d-none');

    axios.post(route('clientAddToCart'), {
        product_id: btn.data('key'),
        quantity: 1,
        on: btn.data('on'),
        adicionales: adicionales,
        combo: panel.attr('data-combo') || undefined,
        grupo: panel.attr('data-grupo') || undefined,
    })
    .then(response => {
        const data = response.data;
        if (!data.status) {
            updateCartUI.showToast(data.message, '#dc3545');
            // El día pudo haber cambiado en otra pestaña (p. ej. ya se completó
            // el combo): se muestra el estado real en vez del paso viejo.
            return refrescar(panel);
        }
        updateCartUI.updateCartCount(data.cart.items_count);
        updateCartUI.showToast(data.message);
        return refrescar(panel);
    })
    .catch(e => error(e, 'No se pudo agregar el producto al carrito'))
    .then(() => {
        // Si el panel se reemplazó, esto actúa sobre el viejo, ya fuera de la página.
        ocupado(panel, false);
        btn.find('.spinner').addClass('d-none');
    });
}

/**
 * Quita una unidad de la línea elegida: el panel vuelve al paso que quedó
 * incompleto, en ese mismo combo.
 */
function cambiar(btn) {
    const panel = btn.closest('.combo-dia');
    const hash = btn.data('hash');
    const cantidad = parseInt(btn.data('cantidad'));

    ocupado(panel, true);

    const request = cantidad > 1
        ? axios.post(route('clientUpdateCart'), { item_id: hash, quantity: cantidad - 1 })
        : axios.post(route('clientItemDeleteCart'), { item_id: hash, todo_el_dia: 0 });

    request
        .then(response => {
            const data = response.data;
            if (!data.status) {
                updateCartUI.showToast(data.message, '#dc3545');
                return refrescar(panel);
            }
            updateCartUI.updateCartCount(data.cart.items_count);
            return refrescar(panel);
        })
        .catch(e => {
            error(e, 'No se pudo cambiar el producto');
            // La línea pudo haber cambiado en otra pestaña: se muestra el estado real.
            refrescar(panel);
        });
}

export default function initCombo() {
    $(document).on('click', '.combo-elegir', function (e) {
        e.preventDefault();
        elegir($(this));
    });

    $(document).on('click', '.combo-cambiar', function (e) {
        e.preventDefault();
        cambiar($(this));
    });

    $(document).on('click', '.combo-elegir-combo', function (e) {
        e.preventDefault();
        const panel = $(this).closest('.combo-dia');
        refrescar(panel, { combo: $(this).data('combo'), nuevo: parseInt(panel.attr('data-nuevo')) === 1 });
    });

    $(document).on('click', '.combo-armar-otro', function (e) {
        e.preventDefault();
        refrescar($(this).closest('.combo-dia'), { nuevo: true });
    });

    // Arrepentirse de "Armar otro combo" antes de elegir nada: el carrito no
    // cambió, así que el panel vuelve al resumen (o a "Ya pediste").
    $(document).on('click', '.combo-cancelar', function (e) {
        e.preventDefault();
        refrescar($(this).closest('.combo-dia'), { soltar: true });
    });

    $(document).on('click', '.combo-siguiente-dia', function (e) {
        e.preventDefault();
        const tab = document.getElementById($(this).data('tab'));
        if (!tab) {
            return;
        }
        new window.bootstrap.Tab(tab).show();
        alPanel($('#days'));
    });
}
